export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 7C22 5.34315 20.6569 4 19 4H5C3.34315 4 2 5.34315 2 7V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V7ZM5 6H19C19.5523 6 20 6.44772 20 7V17C20 17.5523 19.5523 18 19 18H5C4.44772 18 4 17.5523 4 17V7C4 6.44772 4.44772 6 5 6ZM6.661 7.71693L12.0031 11.0144L17.4123 7.7142C17.8838 7.42656 18.4991 7.57558 18.7868 8.04705C19.0744 8.51852 18.9254 9.1339 18.4539 9.42154L12.5208 13.0413C12.1994 13.2374 11.7951 13.2363 11.4747 13.0386L5.61049 9.41882C5.14052 9.12873 4.99471 8.51258 5.2848 8.04262C5.57489 7.57265 6.19103 7.42684 6.661 7.71693Z"
      fill="currentColor"
    />
  </svg>
);
